/**
 * Zone color utilities (simplified — no on-chain farming mechanics).
 */

const MAX_ZONE = 29;

/** Returns [r, g, b] in 0-1 range for Three.js vertex colors. */
export function getZoneColorRGB(zone: number): [number, number, number] {
	const t = Math.min(1, Math.max(0, zone / MAX_ZONE));
	const hue = 130 * (1 - t);
	const sat = (70 + t * 10) / 100;
	const light = (55 - t * 10) / 100;
	return hslToRgb(hue / 360, sat, light);
}

function hslToRgb(h: number, s: number, l: number): [number, number, number] {
	const a = s * Math.min(l, 1 - l);
	const f = (n: number) => {
		const k = (n + h * 12) % 12;
		return l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
	};
	return [f(0), f(8), f(4)];
}

/** Short label for the zone. */
export function formatZoneDuration(_zone: number): string {
	return `Zone ${_zone}`;
}

/** Zone label. */
export function formatZoneMultiplier(_zone: number): string {
	return "";
}
